import { render, staticRenderFns } from "./InvoiceNew.vue?vue&type=template&id=b143f1d2&scoped=true"
import script from "./InvoiceNew.vue?vue&type=script&lang=js"
export * from "./InvoiceNew.vue?vue&type=script&lang=js"
import style0 from "./InvoiceNew.vue?vue&type=style&index=0&id=b143f1d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b143f1d2",
  null
  
)

export default component.exports